import * as consts from '../constants';
import initialState from './initialState';

export default function tariffGroupReducer(state = initialState.tariffGroupState, action) {
    switch (action.type) {
        case consts.ACTONS.LOAD_TARIFF_GROUPS_SUCCESS:
            return action.pagingModel;
        case consts.ACTONS.LOAD_TARIFF_GROUPS_FAILED:
            return initialState.tariffGroupState;
        default:
            return state;
    }
}